module.exports = __webpack_public_path__ + "static/media/15.08ae3b8b.png";